import { createAction, props, union } from '@ngrx/store';

import { KeyValueDict } from '@global/infrastructure/interfaces/key-value-dict';

export const nextButtonClicked = createAction(
  '[YourAddressNavigation] Next Button Clicked'
);

export const backButtonClicked = createAction(
  '[YourAddressNavigation] Back Button Clicked'
);

export const resetButtons = createAction(
  '[YourAddressNavigation] Reset Buttons'
);

export const setupNavigation = createAction(
  '[YourAddressNavigation] Set Navigation',
  props<{ navCommands: KeyValueDict<string> }>()
);


const all = union({nextButtonClicked, backButtonClicked, resetButtons});
export type YourRegistrationNavigationActionsUnion = typeof all;
